(function(api) {
	
} (konto.ba.api = {}));